// JS para a seção Shuffle Grid

const squareData = [ 
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1547347298-4074fc3086f0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1510925758641-869d353cecc7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1629901925121-8a141c2a42f4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1580238053495-b9720401fd45?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 5,
    src: 'https://images.unsplash.com/photo-1569074187119-c87815b476da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1325&q=80',
  },
  {
    id: 6,
    src: 'https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 7,
    src: 'https://images.unsplash.com/photo-1599586120429-48281b6f0ece?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 8,
    src: 'https://plus.unsplash.com/premium_photo-1671436824833-91c0741e89c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 9,
    src: 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 10,
    src: 'https://images.unsplash.com/photo-1610768764270-790fbec18178?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 11,
    src: 'https://images.unsplash.com/photo-1507034589631-9433cc6bc453?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=684&q=80',
  },
  {
    id: 12,
    src: 'https://images.unsplash.com/photo-1533107862482-0e6974b06ec4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=882&q=80',
  },
  {
    id: 13,
    src: 'https://images.unsplash.com/photo-1560089000-7433a4ebbd64?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
  },
  {
    id: 14,
    src: 'https://images.unsplash.com/photo-1517466787929-bc90951d0974?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=686&q=80',
  },
  {
    id: 15,
    src: 'https://images.unsplash.com/photo-1606244864456-8bee63fce472?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=681&q=80',
  },
  {
    id: 16,
    src: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1820&q=80',
  },
];

const SHUFFLE_TRANSITION_SECONDS = 0.5;
const SHUFFLE_INTERVAL_MS = 1900;

const shuffleArray = (array) => {
  const result = array.slice();
  let currentIndex = result.length;
  let randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    [result[currentIndex], result[randomIndex]] = [result[randomIndex], result[currentIndex]];
  }

  return result;
};

const createGridPositions = (container) => {
  const gap = 8;
  const cols = 4;
  const rows = 4;
  const width = Math.floor((container.clientWidth - gap * (cols - 1)) / cols);
  const height = Math.floor((container.clientHeight - gap * (rows - 1)) / rows);
  const positions = [];

  for (let row = 0; row < rows; row += 1) {
    for (let col = 0; col < cols; col += 1) {
      positions.push({
        x: col * (width + gap),
        y: row * (height + gap),
        w: width,
        h: height,
      });
    }
  }

  return positions;
};

const setSquareStyle = (square, position) => {
  square.style.width = `${position.w}px`;
  square.style.height = `${position.h}px`;
  square.style.transform = `translate3d(${position.x}px, ${position.y}px, 0) scale(1)`;
};

const createSquare = (item) => {
  const square = document.createElement('div');
  square.className = 'shuffle-square';
  square.dataset.squareId = item.id;
  square.style.backgroundImage = `url('${item.src}')`;
  square.style.backgroundSize = 'cover';
  square.style.backgroundPosition = 'center';
  square.style.backgroundRepeat = 'no-repeat';
  square.style.transition = `transform ${SHUFFLE_TRANSITION_SECONDS}s ease, width ${SHUFFLE_TRANSITION_SECONDS}s ease, height ${SHUFFLE_TRANSITION_SECONDS}s ease, opacity 0.4s ease`;
  square.style.opacity = '0';
  square.style.transform = 'translate3d(0, 0, 0) scale(1)';
  return square;
};

const setupShuffleGrid = () => {
  const section = document.querySelector('[data-shuffle-grid]');
  if (!section) return;

  const grid = section.querySelector('.shuffle-grid');
  if (!grid) return;
  grid.innerHTML = '';

  const positions = createGridPositions(grid);
  const squares = squareData.map((item) => createSquare(item));
  const assignedPositions = shuffleArray(positions);

  squares.forEach((square, index) => {
    setSquareStyle(square, assignedPositions[index]);
    grid.appendChild(square);
  });

  window.requestAnimationFrame(() => {
    squares.forEach((square) => {
      square.style.opacity = '1';
    });
  });

  const shuffleSquares = () => {
    const nextPositions = shuffleArray(positions);

    squares.forEach((square, index) => {
      setSquareStyle(square, nextPositions[index]);
    });
  };

  let interval = setInterval(shuffleSquares, SHUFFLE_INTERVAL_MS);

  section.addEventListener('mouseenter', () => {
    clearInterval(interval);
  });

  section.addEventListener('mouseleave', () => {
    interval = setInterval(shuffleSquares, SHUFFLE_INTERVAL_MS);
  });

  window.addEventListener('resize', () => {
    const updatedPositions = createGridPositions(grid);
    squares.forEach((square, index) => {
      setSquareStyle(square, updatedPositions[index]);
    });
  });
};

export default setupShuffleGrid;
